import Hero from '../components/Hero';
import About from '../components/About';
import Courses from '../components/Courses';
import Contact from '../components/Contact';

function Home() {
  return (
    <div>
      <Hero />
      <About />
      <Courses />
      <Contact />
    </div>
  );
}

export default Home; 